"use strict";

var get = require('lodash/get');

var isEmpty = require('lodash/isEmpty');

var pickBy = require('lodash/pickBy');

var identity = require('lodash/identity');

var storage = require('@flowio/storage');

function getSession() {
  /*
   * Use session storage first for temporary, marketing driven sessions that may need to be tracked
   * differently than permanent sessions on the same website.
   */
  return storage.session.get('session') || storage.local.get('session') || storage.memory.get('session');
}

function isTemporarySession() {
  return !isEmpty(storage.session.get('session'));
}

function getSessionId() {
  return get(getSession(), 'id');
}

function getVisitorId() {
  return get(getSession(), 'visitor.id');
}

function getVisitId() {
  return get(getSession(), 'visit.id');
}

function getVisitExpiration() {
  return get(getSession(), 'visit.expires_at');
}

function getAttributes() {
  return get(getSession(), 'attributes');
}

function getSessionDiscriminator() {
  return get(getSession(), 'discriminator');
}

function getExperience() {
  return get(getSession(), 'experience.key') || get(getSession(), 'local.experience.key');
}

function getExperienceRegion() {
  return get(getSession(), 'experience.region.id' || get(getSession(), 'local.experience.region.id'));
}

function getCountry() {
  return get(getSession(), 'geo.country.iso_3166_3') || get(getSession(), 'local.country.iso_3166_3');
}

function getCurrency() {
  return get(getSession(), 'geo.currency.iso_4217_3') || get(getSession(), 'local.currency.iso_4217_3');
}

function getLanguage() {
  return get(getSession(), 'geo.language.iso_639_2') || get(getSession(), 'local.language.iso_639_2');
}

function getLocale() {
  return get(getSession(), 'geo.locale.id') || get(getSession(), 'local.locale.id');
}

function getOrganization() {
  return get(getSession(), 'organization');
}

function getEnvironment() {
  return get(getSession(), 'environment');
}

function getExperimentKey() {
  return get(getSession(), 'experiment.key');
}

function getExperimentVariantKey() {
  return get(getSession(), 'experiment.variant.key');
}

function getExperiment() {
  if (getExperimentKey() && getExperimentVariantKey()) {
    return get(getSession(), 'experiment');
  }

  return undefined;
}
/**
 * @deprecated
 */


function getExperiments() {
  return get(getSession(), 'experiments');
}

function getIpAddress() {
  return get(getSession(), 'ip');
}

function getFormat() {
  return get(getSession(), 'format');
}

function getGeo() {
  return pickBy({
    country: getCountry(),
    currency: getCurrency(),
    language: getLanguage(),
    locale: getLocale()
  }, identity);
}

module.exports = {
  getSession: getSession,
  getVisitorId: getVisitorId,
  getVisitId: getVisitId,
  getVisitExpiration: getVisitExpiration,
  getSessionId: getSessionId,
  getAttributes: getAttributes,
  getSessionDiscriminator: getSessionDiscriminator,
  getExperience: getExperience,
  getExperienceRegion: getExperienceRegion,
  getCountry: getCountry,
  getCurrency: getCurrency,
  getLanguage: getLanguage,
  getLocale: getLocale,
  getOrganization: getOrganization,
  getEnvironment: getEnvironment,
  getExperiment: getExperiment,
  getExperiments: getExperiments,
  getIpAddress: getIpAddress,
  getFormat: getFormat,
  getGeo: getGeo,
  isTemporarySession: isTemporarySession
};


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/session/lib/index.js
// module id = 7
// module chunks = 0 1